import skyovalbackground from "../../../assets/images/skyovalbackground.png";
import archetypesskyovalbackground from "../../../assets/images/archetypesskyovalbackground.png";
import "./Archetypes.scss";
import { useEffect, useRef } from "react";
import * as $ from "jquery";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel";
import IconTabs from "./IconTabs";
import { CarouselData } from "./Data";

const Archetypes = () => {
  const maintitle = useRef();
  const carouselfirstarchetype = useRef();

  useEffect(() => {
    $(window).scroll(function (event) {
      let scrollPosition = $(this).scrollTop();

      if (window.innerWidth < 577) {
        if (scrollPosition >= 472 && scrollPosition <= 1157) {
          maintitle.current.style.setProperty("left", "0%");
          maintitle.current.style.setProperty("position", "relative");
        } else {
          maintitle.current.style.setProperty("left", "100%");
          maintitle.current.style.setProperty("position", "relative");
        }

        if (scrollPosition >= 795 && scrollPosition <= 1710) {
          carouselfirstarchetype.current.style.setProperty(
            "transform",
            "scale(1)"
          );
        } else {
          carouselfirstarchetype.current.style.setProperty(
            "transform",
            "scale(0)"
          );
        }
      } else {
        console.log(scrollPosition);
      }
    });
  }, []);

  const onDrag = (event) => {
    console.log(event);
  };
  const onViewMoreResilience = () => {};
  const onViewMoreHighSocialImpactProjects = () => {};
  const onViewMorePublicInfrastructure = () => {};
  const onViewMoreBankableProjects = () => {};
  const handleButtonClick = (id) => {
    switch (id) {
      case 1:
        onViewMoreResilience();
        break;
      case 2:
        onViewMoreHighSocialImpactProjects();
        break;
      case 3:
        onViewMorePublicInfrastructure();
        break;
      case 4:
        onViewMoreBankableProjects();
        break;
      default:
        console.log("No action specified");
    }
  };
  return (
    <section>
      <div className="archetypes">
        <img
          className="skyovalbackground mobile"
          src={skyovalbackground}
          alt="skyovalbackground"
        />
        <img
          className="skyovalbackground desktop"
          src={archetypesskyovalbackground}
          alt="skyovalbackground"
        />
        <div className="container">
          <div id="maintitle" className="title" ref={maintitle}>
            <span>+$9Bn investment across 4 project archetypes</span> identified
            to enable Lagos build resilience to climate impacts
          </div>
          <div className="subtitle">
            Development partners’ opportunities <br />
            Investment required: <span>+$9Bn</span>
          </div>
          <OwlCarousel
            className="owl-theme mobile"
            margin={0}
            nav
            items={1}
            onDragged={onDrag}
          >
            {CarouselData?.map((item) => (
              <div key={item.id} className="item cid-carousel">
                <div className="overflow-content">
                  <div className="custom-row space-between">
                    <img
                      id={`archetype-icon-${item.id}`}
                      src={item?.image}
                      alt={item?.title}
                      className="archetype-img"
                    />
                    <div className="cid-title">{item.title}</div>
                  </div>
                  <div className="custom-col">
                    <div className="cid-driver-bullet-parent">
                      <div className="archetypes-title">DESCRIPTION</div>
                      <div className="archetypes-desc">{item.description}</div>
                    </div>

                    <div className="cid-driver-bullet-parent space-top">
                      <div className="archetypes-title">
                        POTENTIAL TYPE OF EXTERNAL FUNDING
                      </div>
                      {item.funding.map((fund, index) => (
                        <div key={index} className="cid-driver-bullet">
                          &bull; {fund}
                        </div>
                      ))}
                    </div>

                    <div className="custom-col">
                      <div>
                        <div className="portfolio-title"># OF PROJECTS</div>
                        <div className="portfolio-subtitle">
                          {item.projects}
                        </div>
                      </div>
                      <div>
                        <div className="portfolio-title">
                          TOTAL PROJECT PORTFOLIO BUDGET
                        </div>
                        <div className="portfolio-subtitle">{item.budget}</div>
                      </div>
                    </div>

                    <div className="cid-driver-bullet-parent space-top">
                      <div className="archetypes-title">PROJECTS</div>
                      {item.projectList.map((project, index) => (
                        <div key={index} className="cid-driver-bullet">
                          &bull; {project}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <a href={item.link} className="space-left">
                  <button
                    className="view-more-button"
                    onClick={handleButtonClick(item.id)}
                  >
                    VIEW DETAILS
                  </button>
                </a>
              </div>
            ))}
          </OwlCarousel>
          <IconTabs />
        </div>
      </div>
    </section>
  );
};

export default Archetypes;
